module.exports = __webpack_public_path__ + "img/login-bg-fc0dbc5cbcc2dcb21925a1e65b8852bd.svg";